import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "endpoint", "method", "path", "body", "bodyGroup", "token", "send", "status", "response" ]
  static values = { baseUrl: String, buyerAccountId: String }

  connect() {
    if (this.hasEndpointTarget) this.selectEndpoint()
  }

  selectEndpoint() {
    const option = this.endpointTarget.selectedOptions[0]
    if (!option) return

    this.methodTarget.value = option.dataset.method
    this.pathTarget.value = option.dataset.path
    this.bodyTarget.value = option.dataset.body || ""
    this.bodyGroupTarget.classList.toggle("d-none", option.dataset.method === "GET")
  }

  async send(event) {
    event.preventDefault()

    const method = this.methodTarget.value
    const path = this.pathTarget.value.trim()
    const headers = { "Accept": "application/json" }
    const token = this.tokenTarget.value.trim()
    const options = { method, headers, credentials: "same-origin" }

    if (token) headers.Authorization = `Bearer ${token}`
    if (this.hasBuyerAccountIdValue) headers["X-Buyer-Account-ID"] = this.buyerAccountIdValue

    if (method !== "GET" && this.bodyTarget.value.trim()) {
      try {
        options.body = JSON.stringify(JSON.parse(this.bodyTarget.value))
      } catch (_error) {
        this.renderClientError("Request body must be valid JSON.")
        return
      }
      headers["Content-Type"] = "application/json"
      const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
      if (csrfToken) headers["X-CSRF-Token"] = csrfToken
    }

    this.sendTarget.disabled = true
    this.sendTarget.textContent = "Sending…"
    this.statusTarget.textContent = "Request in progress"
    this.statusTarget.className = "badge theme-secondary"

    try {
      const response = await fetch(`${this.baseUrlValue}${path}`, options)
      const text = await response.text()
      let body

      try {
        body = JSON.stringify(JSON.parse(text), null, 2)
      } catch (_error) {
        body = text
      }

      this.statusTarget.textContent = `${response.status} ${response.statusText}`
      this.statusTarget.className = `badge ${response.ok ? "theme-success" : "theme-danger"}`
      this.responseTarget.textContent = body || "(empty response)"
    } catch (error) {
      this.renderClientError(error.message)
    } finally {
      this.sendTarget.disabled = false
      this.sendTarget.textContent = "Send request"
    }
  }

  renderClientError(message) {
    this.statusTarget.textContent = "Request error"
    this.statusTarget.className = "badge theme-danger"
    this.responseTarget.textContent = message
  }
}
